import { render, staticRenderFns } from "./ActorPageView.vue?vue&type=template&id=25fecd91&scoped=true"
import script from "./ActorPageView.vue?vue&type=script&lang=js"
export * from "./ActorPageView.vue?vue&type=script&lang=js"
import style0 from "./ActorPageView.vue?vue&type=style&index=0&id=25fecd91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fecd91",
  null
  
)

export default component.exports